import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import OrderCheckoutProduct from '../../../../../models/order/checkout/OrderCheckoutProduct';
import ProductImageModel from '../../../../../models/ProductImage';
import { modelOf } from '../../../../../prop-types';
import RouteService from '../../../../../services/RouteService';
import ProductImage from '../../../../product/ProductImage';

const CheckoutCartProductImage = ({ product, routeService }) => {
  const url = product.image_url || product.image;
  const productImage = url
    ? ProductImageModel.create({
        id: 0,
        product_id: product.id,
        sizes: { small: url },
      })
    : null;

  const canonicalUrl = routeService.getCanonicalProductPath(product);
  const imageNode = (
    <div className="CheckoutCartProductRow__product-image">
      <ProductImage
        product={product}
        productImage={productImage}
        size="small"
        forceAspectRatio={false}
        width={75}
        height={75}
      />
    </div>
  );

  if (canonicalUrl) {
    return <Link to={canonicalUrl}>{imageNode}</Link>;
  }
  return imageNode;
};

CheckoutCartProductImage.propTypes = {
  routeService: PropTypes.instanceOf(RouteService).isRequired,
  product: modelOf(OrderCheckoutProduct).isRequired,
};

export default inject('routeService')(observer(CheckoutCartProductImage));
